<template>
  <v-row>
    <v-col class="px-0">
      <v-card>
        <v-card-title>
          <span>Prêmios</span>
          <v-spacer />
          <mf-button v-if="!isDisabled" label="Criar novo prêmio" text color="marca-0-l40" icon="add" @click="openPrizeDialog" />
          <div class="pr-3"></div>
          <mf-search v-model="prizeSearch" class="pa-0 mr-3 text-field-width" dense style="max-width: 300px" hide-details placeholder="Busque por um prêmio" />
        </v-card-title>
        <v-card-text>
          <raffle-table
            class="mb-n4"
            :items="raffle.prizes"
            :search.sync="prizeSearch"
            :headers="prizesTableHeader"
            :filter-items-by-search="prizeFilterItemsBySearch"
          >
            <template v-slot:item="{ item, index, props }">
              <tr :key="`prize-${index}`">
                <td class="table-text--gray">
                  <a :href="item.image_url" target="_blank" class="cinza-l60-text text-decoration-none">
                    <mf-icon v-show="!item.isProduct">image</mf-icon>
                  </a>
                </td>
                <td class="table-text--gray">
                  <v-tooltip v-model="showTooltipTitle[item.title]" max-width="300" top content-class="truncated-tooltip">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ item.title | truncate({ length: 60 }) }}
                      </span>
                    </template>
                    <span>{{ item.title }}</span>
                  </v-tooltip>
                </td>
                <td class="table-text--gray">
                  {{ item.eligibility_start_date | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }} -
                  {{ item.eligibility_end_date | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}
                </td>
                <td class="table-text--gray">{{ item.raffle_date | date({ fmtIn: 'yyyy-mm-dd', fmtOut: 'dd/mm/yyyy' }) }}</td>
                <td class="table-text--gray">{{ item.quantity }}</td>
                <td class="table-text--gray">
                  <mf-icon fill small :color="getPrizeStatusColor(item.given)">fiber_manual_record</mf-icon>
                  {{ getFormatedPrizeStatus(item.given) }}
                </td>
                <td class="text-right">
                  <v-menu v-if="!isDisabled" class="campaigns-table-actions" bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="v-list-item--link" @click="deletePrize(index, props)">Remover</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="v-list-item--link" @click="setEditingPrize(index, props)">Editar</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </raffle-table>
          <p v-if="errorPrize !== ''" class="error--text error-text my-2 pa-2">{{ errorPrize }}</p>
          <mf-info-card v-if="dateHoles.length" icon="warning" class="mt-3" variant="warning" :vHtml="warningHolesContent" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import RaffleTable from './RaffleTable.vue'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
export default {
  name: 'PrizesTable',
  components: {
    RaffleTable,
  },
  filters: {
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY')
    },
  },
  props: {
    openPrizeDialog: {
      required: false,
      type: Function,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    errorPrize: {
      type: String,
      required: false,
    },
    setEditingPrize: {
      required: false,
      type: Function,
    },
    deletePrize: {
      required: false,
      type: Function,
    },
  },
  data: () => ({
    prizeSearch: '',
    showTooltipTitle: {},
    prizesTableHeader: [
      {
        text: 'Imagem',
        value: 'image_url',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Nome',
        value: 'title',
        width: '25%',
        sortable: false,
      },
      {
        text: 'Período de compras elegíveis',
        value: 'eligibility_start_date',
        width: '20%',
        sortable: false,
      },
      {
        text: 'Data de sorteio',
        value: 'raffle_date',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Quantidade',
        value: 'quantity',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        width: '15%',
        sortable: false,
      },
      {
        text: '',
        value: '',
        sortable: false,
        width: '5%',
      },
    ],
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    dateHoles() {
      if (!this.raffle?.prizes?.length) {
        return []
      }

      const ranges = this.raffle.prizes.map((prize) => ({ start: moment(prize.eligibility_start_date), end: moment(prize.eligibility_end_date) }))
      const minStartDate = moment(Math.min(...ranges.map((range) => range.start.valueOf())))
      const maxEndDate = moment(Math.max(...ranges.map((range) => range.end.valueOf())))
      const date = minStartDate
      const dateHoles = []
      // eslint-disable-next-line no-unmodified-loop-condition
      while (date <= maxEndDate) {
        if (!ranges.some((range) => range.start <= date && range.end >= date)) {
          dateHoles.push(date.format('DD/MM/YYYY'))
        }
        date.add(1, 'days')
      }
      return dateHoles
    },
    warningHolesContent() {
      const dateHolesLabel = this.dateHoles.length === 1 ? `Existe ${this.dateHoles.length} dia` : `Existem ${this.dateHoles.length} dias`
      return `<span style="color: #B58943">${dateHolesLabel} sem prêmios elegíveis no intervalo do sorteio com a configuração atual de prêmios.</span>`
    },
  },
  methods: {
    getPrizeStatusColor(given) {
      if (given) return '#0079F2'
      return '#FACA00'
    },
    getFormatedPrizeStatus(given) {
      if (given) return 'Sorteado'
      return 'Aguardando sorteio'
    },
    prizeFilterItemsBySearch(item, search) {
      const searchRegex = diacriticSpaceSensitiveRegex(search)
      return item.title.match(searchRegex) || `${item.quantity}` === this.search
    },
  },
}
</script>

<style lang="scss" scoped>
.error--text {
  font-size: 12px;
}
.cinza-l60-text {
  color: $cinza-l60;
}
.link {
  text-decoration-line: none !important;
  text-transform: inherit;
}
</style>
